var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A2AEBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.908 6.483v8.109c0 1.583 1.125 2.233 2.492 1.45l1.958-1.117c.425-.242 1.134-.267 1.575-.042l4.375 2.192c.442.217 1.15.2 1.575-.042l3.609-2.066c.458-.267.841-.917.841-1.45V5.408c0-1.583-1.125-2.233-2.491-1.45l-1.959 1.117c-.425.242-1.133.267-1.575.042L7.933 2.933c-.441-.216-1.15-.2-1.575.042L2.75 5.042c-.467.266-.842.916-.842 1.441ZM7.133 3.333v10.834M13.108 5.517v11.15"
  })));
};
export default SvgMap;